



























import Vue from "vue"

interface ExchangeForm {
  exchangeNumber: number
}

export interface IExchangeGroup extends Vue {
  form: ExchangeForm

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      form: {
        exchangeNumber: 1
      }
    }
  },
  props: {
    parcelNumber: {
      type: Number,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      this.form = {
        exchangeNumber: 1
      }
    }
  }
})
